var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9557 28.02H1.54538C0.691642 28.02 0 27.3279 0 26.4745V1.5654C0 0.711768 0.691751 0.0200195 1.54538 0.0200195H26.4547C27.3081 0.0200195 28 0.711768 28 1.5654V26.4745C28 27.3281 27.308 28.02 26.4547 28.02H19.3196V17.1769H22.9591L23.5041 12.9511H19.3196V10.2532C19.3196 9.02977 19.6593 8.19602 21.4138 8.19602L23.6514 8.19504V4.41549C23.2644 4.36399 21.9361 4.24894 20.3907 4.24894C17.1645 4.24894 14.9557 6.21824 14.9557 9.83473V12.9511H11.3068V17.1769H14.9557V28.02Z",
    fill: "#4460A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1418"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.159668,
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.2facdafda621cae98503971eae87dedb.svg";
export { ForwardRef as ReactComponent };